import { EventEmitter } from '@angular/core';
import { FormControl } from "@angular/forms";
import moment from "moment";
import { MatDatepicker } from "@angular/material/datepicker";
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/form-field";
import * as i2 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i3 from "@angular/material/select";
import * as i4 from "@angular/forms";
import * as i5 from "@angular/common";
import * as i6 from "@angular/material/datepicker";
import * as i7 from "@angular/material/core";
const _c0 = ["datePickerDesktop"];
const _c1 = ["datePickerMobile"];
function OrganizationDashboardDepartmentAndTimeSelectionComponent_mat_option_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const d_r10 = ctx.$implicit;
    i0.ɵɵproperty("value", d_r10);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(d_r10);
} }
function OrganizationDashboardDepartmentAndTimeSelectionComponent_mat_option_12_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ti_r11 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ti_r11);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r1.getIntervalText(ti_r11));
} }
function OrganizationDashboardDepartmentAndTimeSelectionComponent_mat_option_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const d_r12 = ctx.$implicit;
    i0.ɵɵproperty("value", d_r12);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(d_r12);
} }
function OrganizationDashboardDepartmentAndTimeSelectionComponent_mat_option_36_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-option", 23);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ti_r13 = ctx.$implicit;
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("value", ti_r13);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate(ctx_r6.getIntervalText(ti_r13));
} }
export class OrganizationDashboardDepartmentAndTimeSelectionComponent {
    constructor() {
        this.onDepartmentChange = new EventEmitter();
        this.onTimeIntervalChange = new EventEmitter();
        this.depCtrl = new FormControl();
        this.intervalCtrl = new FormControl();
        this.intervals = ['All time', 30, 60, 90, 'Custom range'];
        this.yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
    }
    ngOnInit() { }
    getIntervalText(interval) {
        if (interval === 30 || interval === 60 || interval === 90)
            return 'last ' + interval + ' days';
        else
            return interval;
    }
    selectDepartments() {
        let value;
        if (this.selectedDepartments) {
            if (this.selectedDepartments.length > 0) {
                value = this.selectedDepartments;
            }
        }
        this.onDepartmentChange.emit(value);
        console.log(value);
    }
    selectInterval() {
        let value = this.selectedInterval ? this.selectedInterval : 1800;
        let defaultIntervals = ['All time', 30, 60, 90, 'Custom range'];
        if (value === 'Custom range') {
            if (window.innerWidth < 768) {
                this.datePickerMobile.open();
            }
            else {
                this.datePickerDesktop.open();
            }
        }
        else {
            if (defaultIntervals.includes(value) || value === 1800) {
                this.startTime = moment().subtract(value, 'days');
                this.endTime = moment();
                this.onTimeIntervalChange.emit([this.startTime, this.endTime]);
            }
            else {
                this.intervals = ['All time', 30, 60, 90, value];
                if (window.innerWidth < 768) {
                    this.datePickerMobile.open();
                }
                else {
                    this.datePickerDesktop.open();
                }
            }
        }
    }
    onChange(event) {
        if (event.value === 'All time') {
            this.selectedInterval = null;
        }
    }
    dateRangeChange(dateRangeStart, dateRangeEnd) {
        this.startTime = moment(dateRangeStart.value);
        this.endTime = moment(dateRangeEnd.value);
        if (this.startTime != null && this.endTime != null && !isNaN(this.endTime.unix())) {
            this.onTimeIntervalChange.emit([this.startTime, this.endTime]);
            this.intervals.pop();
            let dateRangeString = this.startTime.format('DD MMM YYYY') + " - " + this.endTime.format('DD MMM YYYY');
            this.intervals.push(dateRangeString);
            this.intervalCtrl.patchValue(dateRangeString);
        }
    }
}
OrganizationDashboardDepartmentAndTimeSelectionComponent.ɵfac = function OrganizationDashboardDepartmentAndTimeSelectionComponent_Factory(t) { return new (t || OrganizationDashboardDepartmentAndTimeSelectionComponent)(); };
OrganizationDashboardDepartmentAndTimeSelectionComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: OrganizationDashboardDepartmentAndTimeSelectionComponent, selectors: [["organization-dashboard-department-and-time-selection"]], viewQuery: function OrganizationDashboardDepartmentAndTimeSelectionComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
        i0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePickerDesktop = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.datePickerMobile = _t.first);
    } }, inputs: { departments: "departments" }, outputs: { onDepartmentChange: "onDepartmentChange", onTimeIntervalChange: "onTimeIntervalChange" }, decls: 49, vars: 22, consts: [["id", "department-and-time-selection", 1, "olha-theme"], [1, "d-none", "d-md-block"], [1, "d-flex", "justify-content-start", "align-items-center"], [1, "department-selection"], ["appearance", "outline"], ["jhiTranslate", "inukaNgApp.organizationAdmin.departmentSelection.departments"], ["tabindex", "-1", "panelClass", "department-panel", "multiple", "", 1, "form-control", 3, "formControl", "disableOptionCentering", "value", "valueChange", "closed"], [3, "value", 4, "ngFor", "ngForOf"], [1, "time-interval-selection"], ["jhiTranslate", "inukaNgApp.organizationAdmin.departmentSelection.time"], ["tabindex", "-1", "panelClass", "interval-panel", 1, "form-control", 3, "formControl", "disableOptionCentering", "ngModel", "ngModelChange", "closed", "selectionChange"], [1, "datepicker-div"], ["jhiTranslate", "password.labels.selectEnd"], [3, "rangePicker", "max"], ["matStartDate", "", "placeholder", "Start date"], ["dateRangeStart", ""], ["matEndDate", "", "placeholder", "End date", 3, "dateChange"], ["dateRangeEnd", ""], ["matIconSuffix", "", 3, "for"], ["datePickerDesktop", ""], [1, "d-md-none"], [1, "datepicker-div-mobile"], ["datePickerMobile", ""], [3, "value"]], template: function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template(rf, ctx) { if (rf & 1) {
        const _r14 = i0.ɵɵgetCurrentView();
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "mat-form-field", 4);
        i0.ɵɵelement(5, "mat-label", 5);
        i0.ɵɵelementStart(6, "mat-select", 6);
        i0.ɵɵlistener("valueChange", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_valueChange_6_listener($event) { return ctx.selectedDepartments = $event; })("closed", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_closed_6_listener() { return ctx.selectDepartments(); });
        i0.ɵɵtemplate(7, OrganizationDashboardDepartmentAndTimeSelectionComponent_mat_option_7_Template, 2, 2, "mat-option", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "div", 8);
        i0.ɵɵelementStart(9, "mat-form-field", 4);
        i0.ɵɵelement(10, "mat-label", 9);
        i0.ɵɵelementStart(11, "mat-select", 10);
        i0.ɵɵlistener("ngModelChange", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_ngModelChange_11_listener($event) { return ctx.selectedInterval = $event; })("closed", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_closed_11_listener() { return ctx.selectInterval(); })("selectionChange", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_selectionChange_11_listener($event) { return ctx.onChange($event); });
        i0.ɵɵtemplate(12, OrganizationDashboardDepartmentAndTimeSelectionComponent_mat_option_12_Template, 2, 2, "mat-option", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(13, "div", 11);
        i0.ɵɵelementStart(14, "mat-form-field", 4);
        i0.ɵɵelement(15, "mat-label", 12);
        i0.ɵɵelementStart(16, "mat-date-range-input", 13);
        i0.ɵɵelement(17, "input", 14, 15);
        i0.ɵɵelementStart(19, "input", 16, 17);
        i0.ɵɵlistener("dateChange", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_input_dateChange_19_listener() { i0.ɵɵrestoreView(_r14); const _r2 = i0.ɵɵreference(18); const _r3 = i0.ɵɵreference(20); return ctx.dateRangeChange(_r2, _r3); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(21, "mat-hint");
        i0.ɵɵtext(22, "MM/DD/YYYY \u2013 MM/DD/YYYY");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(23, "mat-datepicker-toggle", 18);
        i0.ɵɵelement(24, "mat-date-range-picker", null, 19);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(26, "div", 20);
        i0.ɵɵelementStart(27, "div", 3);
        i0.ɵɵelementStart(28, "mat-form-field", 4);
        i0.ɵɵelement(29, "mat-label", 5);
        i0.ɵɵelementStart(30, "mat-select", 6);
        i0.ɵɵlistener("valueChange", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_valueChange_30_listener($event) { return ctx.selectedDepartments = $event; })("closed", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_closed_30_listener() { return ctx.selectDepartments(); });
        i0.ɵɵtemplate(31, OrganizationDashboardDepartmentAndTimeSelectionComponent_mat_option_31_Template, 2, 2, "mat-option", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 8);
        i0.ɵɵelementStart(33, "mat-form-field", 4);
        i0.ɵɵelement(34, "mat-label", 9);
        i0.ɵɵelementStart(35, "mat-select", 10);
        i0.ɵɵlistener("ngModelChange", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_ngModelChange_35_listener($event) { return ctx.selectedInterval = $event; })("closed", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_closed_35_listener() { return ctx.selectInterval(); })("selectionChange", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_mat_select_selectionChange_35_listener($event) { return ctx.onChange($event); });
        i0.ɵɵtemplate(36, OrganizationDashboardDepartmentAndTimeSelectionComponent_mat_option_36_Template, 2, 2, "mat-option", 7);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(37, "div", 21);
        i0.ɵɵelementStart(38, "mat-form-field", 4);
        i0.ɵɵelementStart(39, "mat-date-range-input", 13);
        i0.ɵɵelement(40, "input", 14, 15);
        i0.ɵɵelementStart(42, "input", 16, 17);
        i0.ɵɵlistener("dateChange", function OrganizationDashboardDepartmentAndTimeSelectionComponent_Template_input_dateChange_42_listener() { i0.ɵɵrestoreView(_r14); const _r2 = i0.ɵɵreference(18); const _r3 = i0.ɵɵreference(20); return ctx.dateRangeChange(_r2, _r3); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(44, "mat-hint");
        i0.ɵɵtext(45, "MM/DD/YYYY \u2013 MM/DD/YYYY");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(46, "mat-datepicker-toggle", 18);
        i0.ɵɵelement(47, "mat-date-range-picker", null, 22);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r4 = i0.ɵɵreference(25);
        const _r9 = i0.ɵɵreference(48);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("formControl", ctx.depCtrl)("disableOptionCentering", true)("value", ctx.selectedDepartments);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.departments);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("formControl", ctx.intervalCtrl)("disableOptionCentering", true)("ngModel", ctx.selectedInterval);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.intervals);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("rangePicker", _r4)("max", ctx.yesterday);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("for", _r4);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("formControl", ctx.depCtrl)("disableOptionCentering", true)("value", ctx.selectedDepartments);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.departments);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("formControl", ctx.intervalCtrl)("disableOptionCentering", true)("ngModel", ctx.selectedInterval);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.intervals);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("rangePicker", _r9)("max", ctx.yesterday);
        i0.ɵɵadvance(7);
        i0.ɵɵproperty("for", _r9);
    } }, directives: [i1.MatFormField, i1.MatLabel, i2.JhiTranslateDirective, i3.MatSelect, i4.NgControlStatus, i4.FormControlDirective, i5.NgForOf, i6.MatDateRangeInput, i6.MatStartDate, i6.MatEndDate, i1.MatHint, i6.MatDatepickerToggle, i6.MatDateRangePicker, i7.MatOption], styles: [".time-interval-selection[_ngcontent-%COMP%]{position:relative}.datepicker-div-mobile[_ngcontent-%COMP%]{visibility:hidden;position:absolute;top:444px;left:0}[_nghost-%COMP%]     .mat-form-field-appearance-outline .mat-form-field-outline{color:#9db7b0}[_nghost-%COMP%]     mat-form-field{width:100% !important}[_nghost-%COMP%]     .mat-form-field-infix{height:70px}[_nghost-%COMP%]     .mat-select{height:30px}[_nghost-%COMP%]     .mat-pseudo-checkbox{border:1px solid #9db7b0}[_nghost-%COMP%]     .mat-form-field-wrapper{padding-bottom:0 !important}[_nghost-%COMP%]     .mat-form-field-label{margin-top:0px !important}[_nghost-%COMP%]  .department-panel, [_nghost-%COMP%]  .interval-panel{margin-top:55px !important;border:1px solid #9db7b0 !important}[_nghost-%COMP%]  .department-panel{margin-left:17px !important}[_nghost-%COMP%]  .interval-panel{margin-left:-6px !important}[_nghost-%COMP%]  .mat-select-panel{min-width:111% !important}[_nghost-%COMP%]  .mat-primary .mat-option.mat-selected:not(.mat-option-disabled){color:#9db7b0 !important}[_nghost-%COMP%]  .mat-option-pseudo-checkbox.mat-pseudo-checkbox-checked{background-color:#9db7b0}[_nghost-%COMP%]  .mat-select:focus{outline:none !important;box-shadow:none !important}[_nghost-%COMP%]  .mat-datepicker-popup{border:1px solid #9db7b0;border-radius:4px}[_nghost-%COMP%]  .mat-option-text{color:#0a4a3a}[_nghost-%COMP%]  .mat-pseudo-checkbox{border-color:#0a4a3a}@media(min-width: 768px){.department-selection[_ngcontent-%COMP%]{margin-right:10px}.time-interval-selection[_ngcontent-%COMP%]{margin-left:10px}.datepicker-div[_ngcontent-%COMP%]{visibility:hidden;position:absolute;top:0;left:0}[_nghost-%COMP%]  .mat-form-field-infix{width:300px}[_nghost-%COMP%]  .mat-datepicker-popup{margin-top:30px !important}[_nghost-%COMP%]  .mat-select-panel{min-width:116% !important}}"] });
